import { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "app/hooks";
import {
  setCustomMessage,
  setOpen
} from "components/action-snackbar/action-snackbar-slice";
import ErrorSnackbarContent from "components/error-snackbar-content";
import { selectCurrentUser } from "features/auth/auth-slice";
import { useCreateFeatureSubscriptionMutation } from "services/paywall";
import type { PaywallFeature } from "services/types/paywall.type";
import { getCurrentRoutePath } from "utils/common";

export default function usePurchasePaywallFeature() {
  const [
    createFeatureSubscription,
    { isLoading: isCreatingFeatureSubscription }
  ] = useCreateFeatureSubscriptionMutation();
  const currentUser = useAppSelector(selectCurrentUser);
  const dispatch = useAppDispatch();

  const purchasePaywallFeature = useCallback(
    (feature: PaywallFeature, number_of_licenses: number, user_id?: number) => {
      return createFeatureSubscription({
        feature_id: Number(feature?.id),
        user_id: !user_id ? Number(currentUser?.id) : user_id,
        number_of_licenses,
        redirect_params: getCurrentRoutePath()
      }).then((response) => {
        if ("data" in response && response.data?.checkout_url) {
          window.location.href = response.data?.checkout_url;
        } else if ("error" in response) {
          dispatch(
            setCustomMessage(<ErrorSnackbarContent response={response} />)
          );
          dispatch(setOpen(true));
        }
      });
    },
    [createFeatureSubscription, currentUser?.id, dispatch]
  );

  return {
    purchasePaywallFeature,
    isCreatingFeatureSubscription
  };
}
